@if (show24hMoneyBackNotification()) {
  <fcom-notification
    data-testid="24-hour-money-back-notification"
    [theme]="NotificationTheme.SUSTAINABILITY"
    [scale]="NotificationScale.LARGE"
    [iconName]="SvgLibraryIcon.TWENTY_FOUR_HOUR_REFUND"
    [buttonStyle]="NotificationButtonStyle.LINK"
    [linkText]="'viewDetails' | finLocalization"
    [horizontal]="true"
    (linkClick)="showModal($event)"
  >
    <span class="content-description" [innerHTML]="'moneyBackHighlightB' | finLocalization | finSafe: 'html'"></span>
  </fcom-notification>
  <fcom-modal
    data-testid="24-hour-money-back-modal"
    [(open)]="modalOpen"
    [title]="(content$ | async)?.teaserTitle"
    [buttons]="ModalButtons.CLOSE"
    (close)="closeModal()"
  >
    <cms-unstyled-fragment class="block pr-medium" [cmsContent$]="content$" [showTitle]="false" />
  </fcom-modal>
}
